import { globalAction } from "../actionTypes";

export const setTheme = data => {
    return {
        type: globalAction.SET_THEME,
        payload: data,
    };
};
